// src/App.js
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './LandingPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage/TermsOfServicePage';
import DeleteAccountPage from './pages/DeleteAccountPage/DeleteAccountPage';
import ProfileLinkFallbackPage from './pages/ProfileLinkFallbackPage/ProfileLinkFallbackPage';
import TripLinkFallbackPage from './pages/TripLinkFallbackPage/TripLinkFallbackPage';
import InviteFallbackPage from './pages/InviteFallbackPage/InviteFallbackPage';
import ProfileRedirect from './ProfileRedirect';
import VisitedMapPage from './pages/VisitedMapPage/VisitedMapPage';
import BlogPage from './pages/BlogPage/BlogPage';
import BlogPostPage from './pages/BlogPostPage/BlogPostPage';
import GetAppPage from './pages/GetAppPage/GetAppPage';

// Dev-only canvas for rendering social media assets (scripts/social). The
// condition is a build-time constant, so production builds drop the route
// and never bundle the page.
const SocialStudio =
  process.env.NODE_ENV === 'development' ? lazy(() => import('./dev/SocialStudio/SocialStudio')) : null;

// Previous app code (commented out for future use)
// import React, { useState, useEffect } from 'react';
// import { onAuthStateChanged } from 'firebase/auth'; // Firebase auth listener
// import { auth } from './firebase'; // Adjust your Firebase import path

// import ChatInterface from './ChatInterface';
// import FlightPage from './pages/FlightPage'; // Import the test page
// import FlightSearchFieldsPage from './pages/FlightSearchFieldsPage';
// import AuthenticationPage from './pages/AuthenticationPage/AuthenticationPage';
// import TripPlanningPage from './pages/TripPlanningPage/TripPlanningPage';
// import ActivityPlanPage from './pages/ActivityPlanPage/ActivityPlanPage';
// import HotelPage from './pages/HotelPage/HotelPage';
// import TripsDashboardPage from './pages/TripsDashboardPage/TripsDashboardPage';
// import TestLayoutPage from './pages/TestLayoutPage/TestLayoutPage';

function App() {
  // Simple routing for landing page, privacy policy, and terms of service
  return (
    <Router>
      <ProfileRedirect>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
        <Route path="/p/:userId" element={<ProfileLinkFallbackPage />} />
        <Route path="/trip/:tripId" element={<TripLinkFallbackPage />} />
        <Route path="/i/:token" element={<InviteFallbackPage />} />
        <Route path="/visited-countries-map" element={<VisitedMapPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/get" element={<GetAppPage />} />
        {SocialStudio && (
          <Route
            path="/social-studio"
            element={
              <Suspense fallback={null}>
                <SocialStudio />
              </Suspense>
            }
          />
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ProfileRedirect>
    </Router>
  );

  // Previous app code with routing and authentication (commented out)
  // const [isAuthenticated, setIsAuthenticated] = useState(false);
  // const [loading, setLoading] = useState(true); // Loading state while checking auth

  // // Firebase auth listener to check if the user is authenticated
  // useEffect(() => {
  //   const unsubscribe = onAuthStateChanged(auth, (user) => {
  //     setIsAuthenticated(!!user); // If user is authenticated, set to true
  //     setLoading(false); // Stop loading once the check is complete
  //   });

  //   return () => unsubscribe(); // Clean up the listener on unmount
  // }, []);

  // if (loading) {
  //   // Optionally render a loading state while checking auth status
  //   return <div>Loading...</div>;
  // }

  // return (
  //   <Router>
  //     <Routes>
  //       {/* Redirect root ("/") to "/chat" */}
  //       <Route path="/" element={<Navigate to="/chat" />} />

  //       <Route path="/test" element={<TestLayoutPage />} />
        
  //       <Route 
  //         path="/chat" 
  //         element={isAuthenticated ? <ChatInterface /> : <AuthenticationPage />} 
  //       />
  //       <Route path="/auth" element={<AuthenticationPage />} />
  //       <Route path="/trip" element={<TripPlanningPage />} />
  //       <Route path="/activity_plan_chat" element={<ActivityPlanPage />} />
  //       <Route path="/hotel" element={<HotelPage />} />
  //       <Route path="/trips" element={<TripsDashboardPage />} />

  //     </Routes>
  //   </Router>
  // );
}

export default App;